import {
  Component, OnInit, NgModule, Output, EventEmitter, ViewChild, Input, OnChanges,
  ViewEncapsulation
} from '@angular/core';
import {MamAdminService} from "../service/mam_service.component";
import {BrowserModule} from "@angular/platform-browser";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {HttpModule} from "@angular/http";
import {DialogModule,ButtonModule,DropdownModule, InputTextModule, PanelModule, DataTableModule, PaginatorModule } from 'primeng/primeng';
import {UserGroupTreeModule} from "./user_tree.component";
import {SearchModule} from "./search.component";
import {SelectItem} from "primeng/components/common/api";
import {Paginator} from "primeng/components/paginator/paginator";
import {CompanyDropDownListModule} from "./company-drop-down-list/company-drop-down-list.component";
import {AttributeGroupTreeModule} from "./attribute-group-tree/attribute-group-tree.component";
import {Logger, Options, Level } from "angular2-logger/core";
import {TranslatePipeMoudle} from "../translate/translate.module.pipe";
import {TranslateServiceForm} from "../translate/translate.service"; // ADD THIS

@Component({
  selector: 'target-device',
  templateUrl: 'target_device.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls : ['./target_device.component.css']
})
export class TargetDeviceComponent implements OnInit, OnChanges {
  @ViewChild('pagi') pagi : Paginator;
  selectedTargetLists: any;
  targetUserList: any;
  selectedUser: any;
  treeReset : any = "";
  num : number = 0;
  targetSelectedUserList: any;

  totalRecord: number = 0;
  searchIsTrue : boolean;
  searchText : string;
  searchId : string;
  eDate : any;
  sDate : any;
  pageMax : any;
  searchIDs : SelectItem[];
  dateIsTrue : boolean;
  targetDeviceList : any;
  selectedDevices : any[]= [];
  selectedCompany : any;
  @Input() company : any;
  @Input() setDeviceTargetList : any;
  @Input() title : any;
  @Output() getTargetUserList: EventEmitter<any> = new EventEmitter();
  translate : TranslateServiceForm;

  constructor(private service: MamAdminService, private logger : Logger, private _translate: TranslateServiceForm) {
    this.translate = _translate;
    this.searchIDs = [];
    this.searchIDs.push({label: '---------------', value: 'all'});
    this.searchIDs.push({label: this.translate.instant('ManagementName'), value: 'name'});
    this.searchIDs.push({label: this.translate.instant('UserName'), value: 'username'});
    this.searchIDs.push({label: this.translate.instant('LANG_MemberNum'), value: 'membernum'});

    this.dateIsTrue = false;
  }

  ngOnInit() {
  }

  ngOnChanges(){
    this.targetUserList = null;
    this.targetDeviceList = null;
    this.treeReset = "true"+this.num++;
    this.selectedDevices = this.setDeviceTargetList;
    this.totalRecord = 0;
    /*this.logger.debug("setDeviceTargetList",this.setDeviceTargetList);*/
  }

  selectedTrees(event) {
    this.logger.debug("selectedTree : ", event);
    this.selectedTargetLists = event;
    this.getGroupUserList(event.id,0,10);
    this.pagi.first =0 ;
    //this.getTargetList.emit(this.selectedTargetLists);
  }


  getSearchModel(event){
    this.logger.debug("event : ",event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchText = event.searchText;
    this.sDate = event.sDate;
    this.eDate = event.eDate;
    this.searchId = event.searchId;

    //this.getUserList(1,"C",1, this.pageMax,this.searchText, "true", this.searchId);
    this.getGroupUserListBySearch(this.selectedTargetLists.id,0, 10,this.searchText,this.searchId);
  }

  paginate(event){
    this.pageMax = event.rows;
    if(this.searchIsTrue){
      this.getGroupUserListBySearch(this.selectedTargetLists.id,event.page, this.pageMax,this.searchText,this.searchId);
    }else{

      this.getGroupUserList(this.selectedTargetLists.id,event.page, this.pageMax);
    }
  }

  onTargetUserSelect(event){
    //this.logger.debug("data",event.data);
    this.getDeviceByUser(event.data.id, 1, 10);
  }
  
  onTargetDeviceSelect(event){
    this.getTargetUserList.emit(this.selectedDevices);
  }

  onSelectedCompany(company) {
    this.selectedCompany = company;
    this.logger.debug("combo - select :" , this.selectedCompany);
  }

  onGroupSelect(event){
    this.logger.debug("selected group : " , event);
    this.selectedTargetLists = event;
    this.getGroupUserList(event.id,0,10);
    this.pagi.first =0 ;
  }

  //-------------------------------------------------------------------------------------------

  getGroupUserList(groupId: number, page: number, size: number) {
    this.service.getGroupUserList(groupId, page, size).subscribe(
      value => {
        let tempLis: any;
        tempLis = value;
        this.targetUserList = value.content;
        this.totalRecord = value.totalElements;
        this.logger.debug("-- tempLis :", tempLis);
      }, error => {
        this.logger.error("-- error : " + error);
      }, () => {

      }
    )

  }

  getGroupUserListBySearch(groupId: number, page: number, size: number, search:string, field:string){
    this.service.getGroupUserListBySearch(groupId,page,size,search,field).subscribe(
      value => {
        this.targetUserList = value.content;
        this.totalRecord = value.totalElements;
        this.logger.debug("-- tempLis :", value.content);
      }, error => {
        this.logger.error("-- error : " + error);
      }, () => { }
    )

  }

  /*getUserList(targetId:number, targetType:string, page:number, max:number, search:string, like:string, field:string){
    this.service.getUserList(targetId, targetType, page, max, search, like, field).subscribe(
      value => {
        //this.user_list = value.rows;

        this.totalRecord = value.total;
        this.logger.debug("-- user_list :", value);
      },
      error => {
        this.logger.error("-- error : " + error);
      },
      () => {
        this.logger.info("-- complate : ");
      }
    )
  }*/

  getDeviceByUser(userID:number, page:number, max:number) {
    this.service.getDeviceByUserId(userID, page, max).subscribe(
      value => {
        this.targetDeviceList = value;
        this.logger.debug("getDeviceByUser :", value);

      },
      error => {
        this.logger.error("-- error : ", error);
      },
      () => {
        this.logger.info("-- complate : ");
      }
    )
  }


}
@NgModule({
  imports:[DialogModule,BrowserModule,ButtonModule,FormsModule,DropdownModule,ReactiveFormsModule,CommonModule,BrowserModule,HttpModule,InputTextModule,PanelModule, DataTableModule,UserGroupTreeModule,PaginatorModule,SearchModule,AttributeGroupTreeModule,CompanyDropDownListModule,TranslatePipeMoudle],
  declarations:[TargetDeviceComponent],
  exports:[TargetDeviceComponent],
  providers:[MamAdminService]
})

export class TargetDeviceModule {
}




// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/component/target_device.component.ts